import React, { useState, useEffect, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import jwt from 'jsonwebtoken';
import Clock from 'react-live-clock';
import {
  Grid,
  // Button,
  Hidden,
  Typography,
  makeStyles,
  Avatar,
  CardMedia,
  // Icon,
  Badge,
  // Button,
} from '@material-ui/core';
// import HelpOutlineRoundedIcon from '@material-ui/icons/HelpOutlineRounded';

import { ReactComponent as LogoIcon } from '../../images/logoIcon.svg';
import { ReactComponent as DashboardIcon1 } from '../../images/DashboardIcon1.svg';
import { ReactComponent as DashboardIcon3 } from '../../images/DashboardIcon3.svg';
import { ReactComponent as DashboardIcon6 } from '../../images/DashboardIcon6.svg';
// import { ReactComponent as NewEntryNoti } from '../../images/Dashboardnewentrybtn.svg';
import {
  NavToggle,
  JobBoardIcon,
  JobBoardFilled,
  DashboardInactive,
  ListingActive,
  SettingsActive,
  // SignOutIcon,
  TimeIcon,
  AppointmentIcon,
  AppointmentFilled,
  TorqueLogoOpen,
  DashboardIcon4,
  ReportIcon,
  Purchases,
  PurchasesActive,
  CheckedCampaignerIcon,
  UncheckedCampaignerIcon,
  ChatsTeardropIcon,
  ChatThreadIconNonActive,
} from '../../constants';
import AddVehicle from '../../components/AddVehicle';
import SearchVehicle from '../../components/SearchVehicle';
import AddCustomer from '../../components/AddCustomer';
import SearchCustomer from '../../components/SearchCustomer';

import { useSharedState } from '../../StoreContext';
import Notification from '../../components/Notification';
import { getUser } from '../../actions/users/co-user-actions';
import NavbarRes from '../Dashboard/Components/NavbarRes/NavbarRes';
import { ClearSearchResults } from '../../actions/inspection/search-customer-vehicle';
import {
  checkInSubscription,
  hasPermission,
  getUserRoleId,
  // getRemainingDays,
} from '../../components/Utils/helper';
import '../../components/NewRepairOrderComp/components/index.scss';
import './mui.scss';
import socket from '../../utils/socket';

import UserDropdown from './UserDropdown';
// import reJoining from '../../utils/socket-rejoining';

// import sound from '../../assets/sounds/notification.wav';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '30rem',
    position: 'absolute',
    zIndex: '999',
    top: '70px',
    right: '0',
    boxShadow: '0 8px 30px rgba(161, 191, 218, 0.16)',
    padding: '25px 0',
    borderRadius: '15px',
    background: '#fff',
    [theme.breakpoints.down('sm')]: {
      width: '80%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  root__dropdown: {
    width: '14rem',
    position: 'absolute',
    zIndex: '999',
    top: '80px',
    right: '0',
    boxShadow: '0 8px 30px rgba(161, 191, 218, 0.16)',
    padding: '25px',
    borderRadius: '15px',
    background: '#fff',
    [theme.breakpoints.down('sm')]: {
      width: '80%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  root__dropdown__main: {
    width: '14rem',
    position: 'absolute',
    zIndex: '999',
    top: '55px',
    right: '2%',
    // boxShadow: '0 8px 30px rgba(161, 191, 218, 0.3)',
    boxShadow: '0px 5px 16px rgba(0, 0, 0, 0.15)',
    padding: '0px 25px ',
    border: '1px solid rgba(221, 233, 251, 1)',
    borderRadius: '15px',
    background: '#fff',
    [theme.breakpoints.down('sm')]: {
      width: '80%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  notification__title: {
    fontWeight: 'bold',
    fontSize: '20px',
    linHeight: '29px',
    color: '#171717',
    padding: '0rem 1.5rem 0.5rem 1.5rem',
  },
  primary__text: {
    color: '#29264A',
    fontSize: '14px',
    lineHeight: '19px',
  },
  secondary__text: {
    color: '#95989A',
    fontSize: '13px',
    lineHeight: '16px',
    width: '70%',
    paddingTop: '0.3rem',
  },

  avatar__size: {
    height: '54px',
    width: '54px',
    marginRight: '0.7rem',
  },
  listItem__spacing: {
    padding: '0.6rem 25px',
    background: 'rgba(105, 33, 196, 0.1)',
    '&:hover': {
      background: 'rgba(105, 33, 196, 0.2)',
    },
  },
  dropdown__menu__text: {
    fontWeight: '600',
    fontSize: '13px',
    lineHeight: '16px',
    color: '#6D7D8B',
    padding: '1rem 0',
    cursor: 'pointer',
  },
  cursor__pointer: {
    cursor: 'pointer',
    marginLeft: '10px',
  },
  mechanic__photo: {
    borderRadius: '100px',
    width: '40px',
    height: '40px',
  },
  customer__icon: {
    width: '100%',
    height: '100%',
  },
  notification__ul: {
    maxHeight: '35vh',
    overflowY: 'scroll',
  },
  is__read: {
    color: '#8F92A1',
  },
  background__highlight: {
    width: '93%',
    background: 'rgba(105, 33, 196, 0)',
    '&:hover': {
      background: 'rgba(236, 236, 238, 0.5)',
    },
  },
  digi__clock: {
    margin: '2rem 0',
    background: 'rgba(0, 0, 0, 0.12)',
    borderRadius: '10px',
    padding: '.8rem',
    width: '96%',
  },
  time: {
    fontSize: '15px',
    fontWeight: '400',
    color: '#fff',
    width: '100%',
    textAlign: 'center',
  },
  day: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#fff',
    width: '100%',
    textAlign: 'center',
    padding: '1rem 0 .5rem 0',
  },
  icon: {
    width: '100%',
  },
  quick__checkout__btn: {
    height: '44px',
    width: '140px',
    fontSize: '13px',
    fontWeight: '500',
    borderRadius: '100px',
    textTransform: 'none',
    boxShadow: 'none',
    color: '#fff',
    background: '#FF6019',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      boxShadow: 'none',
      background: '#FF6019',
    },
  },
  ro__number: {
    fontWeight: '500 !important',
    fontSize: '19px !important',
    color: '#6D7D8B !important',
    marginLeft: '0.45rem',
    paddingTop: '0.1rem !important',
  },
  free__banner: {
    background: '#29264A',
    padding: '.5rem 1.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  free__trial__para: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '19px',
    color: '#fff',
  },
  free__trial__btn: {
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '19px',
    color: '#fff',
    width: '130px',
    height: '36px',
    background: 'rgba(255, 255, 255, 0.15)',
    border: '1.5px solid #FFFFFF',
    borderRadius: '100px',
  },
  bar__height: {
    height: '44px',
    '& > div': {
      height: '100%',
    },
  },
  nav__bar__resp: {
    [theme.breakpoints.between(960, 1130)]: {
      '& .NavbarLeft': {
        width: 'calc(100% - 366px) !important',
      },
      '& .GarrageInfo': {
        '& h2, p': {
          fontSize: '1.1rem !important',
        },
      },
      '& .qc__resp': { fontSize: '12px', width: '106px', height: '32px' },
      '& .circle': {
        width: '28px !important',
        height: '28px !important',
      },
      '& #outerContainer': {
        padding: '0 !important',
      },
      '& .notification': {
        padding: '0 0.5rem 0 0.5rem !important',
      },
    },
  },
  badge: {
    '& .MuiBadge-badge': {
      top: '11px',
      right: '14px',
      background: '#e74c3c',
    },
  },
}));

const Layout = ({ children, noPadding, isJobboard, setCwPart, setPwPart }) => {
  const classes = useStyles();

  const [openAddSearchVehicle, setOpenAddSearchVehicle] = useState(false);
  const [openAddSearchCustomer, setOpenAddSearchCustomer] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const [username, setUserName] = useState();
  const [imgData, setImgData] = useState({});
  // const [roleId, setRoleId] = useState();
  const [state, dispatchAction] = useSharedState();
  const [newMsg, setNewMsg] = useState(null);

  // const [trialStatus, setTrialStatus] = useState();
  // const [trialRemainingDays, setTrialRemainingDays] = useState();

  // const [subscriptionPermission, setSubscriptionPermission] = useState(true);
  const [createRoPermission, setCreateRoPermission] = useState(true);
  const [appointmentPermission, setAppointmentPermission] = useState(true);
  const [jobBoardPermission, setJobBoardPermission] = useState(true);
  const [listingPermission, setListingPermission] = useState(true);
  const [reportsPermission, setReportsPermission] = useState(true);
  const [isAllowedReports, setIsAllowedReports] = useState(false);
  const [isAllowedPurchases, setIsAllowedPurchases] = useState(false);
  const [quichcheckoutPermission, setQuichcheckoutPermission] = useState(true);
  const [poPermission, setPoPermission] = useState(true);
  const [CommunicationPermission, setCommunicationPermission] = useState(true);
  const [isAllowEstimator, setIsAllowEstimator] = useState(true);

  const [isAllowedQC, setIsAllowedQC] = useState(false);
  const [audio, setAudio] = useState(null);

  const { pathname } = useLocation();
  const dispatch = useDispatch();
  // const matchesMedia = useMediaQuery('(max-width:1600px)');

  const setHeader = state?.layout?.setHeader || '';

  const clearStates = (value) => {
    // clearing the context states

    if (value === 'inspection') {
      dispatchAction({
        type: 'clearInpectionState',
        payload: {},
      });

      setCwPart?.('');
      setPwPart?.('');
    } else if (value === 'jobcard') {
      dispatchAction({
        type: 'clearSetJobCardState',
        payload: {},
      });

      dispatchAction({
        type: 'clearEstimateState',
        payload: {},
      });
    } else if (value === 'estimate') {
      dispatchAction({
        type: 'clearEstimateState',
        payload: {},
      });

      dispatchAction({
        type: 'clearInpectionState',
        payload: {},
      });
    } else if (value === 'appointment') {
      dispatchAction({
        type: 'clearAppointmentValues',
        payload: {},
      });
    }
    dispatch(ClearSearchResults());

    // clearing the inspection add reducer states
    dispatch({ type: 'CLEAR_ADD_INSPECTION_STATES', payload: {} });
  };

  const updateSubscriptionSuccess = useSelector(
    (st) => st.subscription?.updateSubscriptionSuccess,
  );

  const trialInfo = useSelector((st) => st.subscription?.trialInfo);

  const toggleSettings = useSelector(
    (st) => st?.settings?.toggleSettings || '',
  );

  const userDetails = JSON.parse(localStorage.getItem('userData')) || {};
  const { token } = userDetails;
  const tokenData = jwt.decode(token);
  // const history = useHistory();
  const { userData, updateUserData } = useSelector((st) => st.coUser);
  const totalUnread = useSelector((st) => st.communication?.totalUnread || 0);

  useEffect(() => {
    // Create a new Audio object when the component mounts
    const audi1o = new Audio(
      'https://ar-public-feature.s3.amazonaws.com/notification.mp3',
    );
    audi1o.volume = 1.0;
    setAudio(audi1o);
  }, []);

  useEffect(() => {
    // const subscriptionPermis = hasPermission(
    //   'settings',
    //   'Subscription Settings',
    // );
    const createRoPermis = hasPermission('repairOrder', 'Create');
    const appointmentPermis = hasPermission('appointments', 'View');
    const jobBoardPermis = hasPermission('jobboard', 'View');
    const listingPermis = hasPermission('listing', 'View');
    const reportsPermis = hasPermission('reports', 'isAllowReports');
    const quickcheckoutPermis = hasPermission(
      'quickcheckout',
      'isAllowQuickcheckout',
    );

    const poPermis = hasPermission('purchases', 'isAllowPo');
    const communicationPermis = hasPermission(
      'communication',
      'isAllowCommunication',
    );
    const estimatorPermis = hasPermission('estimator', 'isAllowEstimator');
    console.log('>>>communicationPermis', communicationPermis);
    if (createRoPermis !== 'owner') {
      // setSubscriptionPermission(subscriptionPermis);
      setCreateRoPermission(createRoPermis);
      setAppointmentPermission(appointmentPermis);
      setJobBoardPermission(jobBoardPermis);
      setListingPermission(listingPermis);
      setReportsPermission(reportsPermis);
      setQuichcheckoutPermission(quickcheckoutPermis);
      setPoPermission(poPermis);
      setCommunicationPermission(communicationPermis);
      setIsAllowEstimator(estimatorPermis);
    }

    setIsAllowedQC(checkInSubscription('quickCheckouts')); // checking quick checkout is in current active plan
    // checking reports is in current active plan
    setIsAllowedReports(checkInSubscription('basicBusinessReports'));
    setIsAllowedPurchases(checkInSubscription('purchaseOrderManagement'));
  }, [updateSubscriptionSuccess]); // also update state on subscription plan change

  useEffect(() => {
    if (trialInfo) {
      const { status = '' } = trialInfo || '';

      if (status) {
        // setTrialStatus(status);
      }
      // setTrialRemainingDays(getRemainingDays());
    }
  }, [trialInfo]);

  // useEffect(() => {
  //   if (tokenData) {
  //     const role = tokenData.roleId;
  //     setRoleId(role);
  //   }
  // }, []);

  // get user success case
  useEffect(async () => {
    if (userData?.name) {
      setUserName(userData.name);
    }

    if (userData?.profileImg) {
      setImgData(userData.profileImg);
    }
  }, [userData?.name, userData?.profileImg]);

  // when user update account settings then also change the user name from header
  useEffect(async () => {
    if (updateUserData?.name && tokenData?.coUserId === updateUserData?.id) {
      setUserName(updateUserData.name);
    }

    if (
      updateUserData?.profileImg &&
      tokenData?.coUserId === updateUserData?.id
    ) {
      setImgData(updateUserData.profileImg);
    }
  }, [updateUserData?.name, updateUserData?.profileImg]);

  useEffect(() => {
    if (!userDetails?.userStore) return; // call api's only if user store exists
    // if redux does't contain user details then call get user api
    if (!userData?.name) {
      dispatch(getUser());
    }
  }, []);

  useEffect(() => {
    if (newMsg?.id) {
      // console.log('>>>>>>>>>ss');
      audio.play().catch((error) => {
        console.error('Error playing audio:', error);
      });
      dispatch({
        type: 'PLUS_UNREAD_COUNT',
        payload: {
          customerId: newMsg?.customerId,
          count: 1,
        },
      });
    }
  }, [newMsg]);

  const joinRooms = () => {
    const rooms = [];
    const room = (tokenData?.userId + '-' + tokenData?.coUserId)?.toString();
    rooms.push(room);

    socket.emit('join_room', {
      room: rooms,
    });
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        console.log(
          '>>>>>>>ssddddd',
          document.visibilityState,
          socket.connected,
        );
        // System woke up or user switched back to the app
        if (tokenData?.coUserId && tokenData?.userId) {
          joinRooms();
        }

        if (!socket.connected) {
          // joinRooms();
          socket.connect(); // Reconnect socket if it's disconnected
        }
      }
    };

    const handleOnline = () => {
      if (!socket.connected) {
        joinRooms();
        console.log('>>>>>>sssssreco');
        //   joinRooms();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('online', handleOnline);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  // -=======new msgs cont socket====
  // success case of send sms or email to customer

  useEffect(() => {
    // socket.emit('connection', () => {});
    if (tokenData?.coUserId && tokenData?.userId) {
      // const rooms = [];
      // const room = (tokenData?.userId + '-' + tokenData?.coUserId)?.toString();
      // rooms.push(room);
      // socket.emit('join_customer_communication', {
      //   room: rooms,
      // });

      socket.on('connect', () => {
        if (socket.connected) {
          joinRooms();
        }
      });

      socket.on('disconnect', (reason) => {
        console.log('>>>>>>Disconnected:', reason);
        if (reason === 'io server disconnect') {
          // If the disconnection was caused by the server, you can manually reconnect
          socket.connect();
        }
      });

      joinRooms();
      socket.on('customerCommunication', (communicationData) => {
        console.log('>>>>com data2222', communicationData);
        if (communicationData) {
          setNewMsg(communicationData);
          console.log(communicationData);
          // setMessages((prev) => [...prev, communicationData]);
        }
      });
      // return () => {
      //   socket.disconnect();
      // };
    }
  }, []);
  const showJobboard =
    getUserRoleId() === 4
      ? toggleSettings?.workInProgress || false
      : jobBoardPermission;
  console.log('>>>>>>>', listingPermission);

  useEffect(() => {
    dispatch({
      type: 'NAV_BAR_STATE',
      payload: navOpen,
    });
  }, [navOpen]);
  return (
    <>
      <Grid container className='main__navigation'>
        <Grid className='navigation' item xs={12}>
          {/* LeftNavbar */}

          <Hidden only={['sm', 'xs']}>
            <div className={clsx('navigation__left', navOpen && 'nav__open')}>
              <NavToggle
                className={clsx('nav__toggle', navOpen && 'nav__toggle__open')}
                onClick={() => setNavOpen(!navOpen)}
              />
              <div className='navigation__left__top'>
                <div className='brand__container'>
                  <Link to='/dashboard'>
                    {navOpen ? (
                      <TorqueLogoOpen className='WhiteLogo' />
                    ) : (
                      <LogoIcon className='WhiteLogo' />
                    )}
                  </Link>
                </div>

                <div className={classes.digi__clock}>
                  <TimeIcon className={classes.icon} />
                  <Typography className={classes.day}>
                    <Clock format='ddd' ticking='true' />
                  </Typography>
                  <Typography className={classes.time}>
                    <Clock format='HH:mm' ticking='true' />
                  </Typography>
                </div>

                <div className={clsx('topIcon', navOpen && 'align__start')}>
                  <Link to='/dashboard' className='nav__link'>
                    {pathname === '/dashboard' ? (
                      <DashboardIcon1
                        className={navOpen ? 'icon__m__0' : 'icon'}
                      />
                    ) : (
                      <DashboardInactive
                        className={navOpen ? 'icon__m__0' : 'icon'}
                      />
                    )}

                    {navOpen && (
                      <span
                        className={clsx(
                          pathname === '/dashboard' && 'nav__text__active',
                          'nav__text',
                        )}
                      >
                        Dashboard
                      </span>
                    )}
                  </Link>

                  {appointmentPermission && (
                    <Link to='/appointments' className='nav__link'>
                      {pathname === '/appointments' ? (
                        <AppointmentFilled
                          className={navOpen ? 'icon__m__0' : 'icon'}
                        />
                      ) : (
                        <AppointmentIcon
                          className={navOpen ? 'icon__m__0' : 'icon'}
                        />
                      )}

                      {navOpen && (
                        <span
                          className={clsx(
                            pathname === '/appointments' && 'nav__text__active',
                            'nav__text',
                          )}
                        >
                          Appointment
                        </span>
                      )}
                    </Link>
                  )}
                  {showJobboard ? (
                    <Link to='/jobboard' className='nav__link'>
                      {pathname === '/jobboard' ? (
                        <JobBoardFilled
                          className={navOpen ? 'icon__m__0' : 'icon'}
                        />
                      ) : (
                        <JobBoardIcon
                          className={navOpen ? 'icon__m__0' : 'icon'}
                        />
                      )}

                      {navOpen && (
                        <span
                          className={clsx(
                            pathname === '/jobboard' && 'nav__text__active',
                            'nav__text',
                          )}
                        >
                          Job Board
                        </span>
                      )}
                    </Link>
                  ) : (
                    ''
                  )}
                  {isAllowedReports && reportsPermission && (
                    <Link to='/reports' className='nav__link'>
                      {pathname === '/reports' ? (
                        <ReportIcon
                          className={navOpen ? 'icon__m__0' : 'icon'}
                        />
                      ) : (
                        <DashboardIcon4
                          className={navOpen ? 'icon__m__0' : 'icon'}
                        />
                      )}

                      {navOpen && (
                        <span
                          className={clsx(
                            pathname === '/reports' && 'nav__text__active',
                            'nav__text',
                          )}
                        >
                          Reports
                        </span>
                      )}
                    </Link>
                  )}
                  {isAllowedPurchases && poPermission && (
                    <Link to='/purchases' className='nav__link'>
                      {pathname === '/purchases' ? (
                        <PurchasesActive
                          className={navOpen ? 'icon__m__0' : 'icon'}
                        />
                      ) : (
                        <Purchases
                          className={navOpen ? 'icon__m__0' : 'icon'}
                        />
                      )}

                      {navOpen && (
                        <span
                          className={clsx(
                            pathname === '/purchases' && 'nav__text__active',
                            'nav__text',
                          )}
                        >
                          Purchases
                        </span>
                      )}
                    </Link>
                  )}

                  {listingPermission && (
                    <Link to='/listing' className='nav__link'>
                      {pathname === '/listing' ? (
                        <ListingActive
                          className={navOpen ? 'icon__m__0' : 'icon'}
                        />
                      ) : (
                        <DashboardIcon3
                          className={navOpen ? 'icon__m__0' : 'icon'}
                        />
                      )}

                      {navOpen && (
                        <span
                          className={clsx(
                            pathname === '/listing' && 'nav__text__active',
                            'nav__text',
                          )}
                        >
                          Lists
                        </span>
                      )}
                    </Link>
                  )}
                  {checkInSubscription('campaigner') &&
                    getUserRoleId() === 4 && (
                      <Link to='/campaigner' className='nav__link'>
                        {pathname === '/campaigner' ? (
                          <CheckedCampaignerIcon
                            className={navOpen ? 'icon__m__0' : 'icon'}
                          />
                        ) : (
                          <UncheckedCampaignerIcon
                            className={navOpen ? 'icon__m__0' : 'icon'}
                          />
                        )}

                        {navOpen && (
                          <span
                            className={clsx(
                              pathname === '/campaigner' && 'nav__text__active',
                              'nav__text',
                            )}
                          >
                            Campaigner
                          </span>
                        )}
                      </Link>
                    )}
                  {checkInSubscription('messaging') &&
                    CommunicationPermission && (
                      <Link to='/communication' className='nav__link'>
                        <Badge
                          badgeContent={totalUnread || 0}
                          color='secondary'
                          className={classes.badge}
                        >
                          {pathname === '/communication' ? (
                            <ChatsTeardropIcon
                              className={navOpen ? 'icon__m__0' : 'icon'}
                            />
                          ) : (
                            <ChatThreadIconNonActive
                              className={navOpen ? 'icon__m__0' : 'icon'}
                            />
                          )}
                        </Badge>

                        {navOpen && (
                          <span
                            className={clsx(
                              pathname === '/communication' &&
                                'nav__text__active',
                              'nav__text',
                            )}
                          >
                            Communication
                          </span>
                        )}
                      </Link>
                    )}
                </div>
              </div>
              <div
                className={clsx(
                  'topIcon settings__icon',
                  navOpen && 'align__start',
                )}
              >
                <Link to='/settings' className='nav__link'>
                  {pathname === '/settings' ? (
                    <SettingsActive
                      className={navOpen ? 'icon__m__0' : 'icon'}
                    />
                  ) : (
                    <DashboardIcon6
                      className={navOpen ? 'icon__m__0' : 'icon'}
                    />
                  )}
                  {navOpen && (
                    <span
                      className={clsx(
                        pathname === '/settings'
                          ? 'nav__text nav__text__active color-white'
                          : 'nav__text ',
                      )}
                    >
                      Settings
                    </span>
                  )}
                </Link>{' '}
              </div>
            </div>
          </Hidden>
          {/* Right Inspection Content */}
          <div className='InspectionRight'>
            <Hidden only={['md', 'lg', 'xl']}>
              <NavbarRes
                repairOrderId={setHeader?.id}
                roId={setHeader?.roId}
                clearStates={clearStates}
                quichcheckoutPermission={quichcheckoutPermission}
                isAllowedQC={isAllowedQC}
                appointmentPermission={appointmentPermission}
                jobBoardPermission={showJobboard}
                isAllowedReports={isAllowedReports}
                reportsPermission={reportsPermission}
                isAllowedPurchases={isAllowedPurchases}
                poPermission={poPermission}
                listingPermission={listingPermission}
              />
            </Hidden>
            <Hidden only={['sm', 'xs']}>
              {/* Inspection Top Navbar */}
              <div className={clsx('InspectionNavbar', classes.nav__bar__resp)}>
                <div className='NavbarLeft'>
                  {setHeader ? (
                    <>
                      <div className='GarrageInfo header__title__ro'>
                        {/* {setHeader?.link} */}
                        <h2>{setHeader?.title} </h2>
                        {/* <span className='ro__number'> */}
                        {setHeader?.inspectionRoId ? (
                          <Typography className={classes.ro__number}>
                            #RO-{setHeader?.inspectionRoId}-
                            {setHeader?.inspectionLength}
                          </Typography>
                        ) : (
                          <Typography className={classes.ro__number}>
                            {setHeader?.id ? '#RO-' : ''}
                            {setHeader?.id}
                            {setHeader?.id && setHeader?.inspectionLength
                              ? `-${setHeader?.inspectionLength}`
                              : ''}
                          </Typography>
                        )}
                        {/* </span> */}
                      </div>
                      {setHeader?.title === 'test' && (
                        <div className='GarrageInfo Garrage__address__name'>
                          <p className='business__name'>
                            {setHeader?.businessName}
                          </p>
                          <p className='business__address'>
                            {setHeader?.address}{' '}
                          </p>
                        </div>
                      )}

                      {isAllowEstimator || createRoPermission ? (
                        <>
                          <AddVehicle
                            toggle={openAddSearchVehicle === 'add'}
                            setToggle={(val) => {
                              setOpenAddSearchCustomer(false);
                              setOpenAddSearchVehicle(val ? 'add' : false);
                            }}
                          />

                          <SearchVehicle
                            toggle={openAddSearchVehicle === 'search'}
                            setToggle={(val) => {
                              setOpenAddSearchCustomer(false);
                              setOpenAddSearchVehicle(val ? 'search' : false);
                            }}
                          />

                          <AddCustomer
                            toggle={openAddSearchCustomer === 'add'}
                            setToggle={(val) => {
                              setOpenAddSearchVehicle(false);
                              setOpenAddSearchCustomer(val ? 'add' : false);
                            }}
                          />

                          <SearchCustomer
                            toggle={openAddSearchCustomer === 'search'}
                            setToggle={(val) => {
                              setOpenAddSearchVehicle(false);
                              setOpenAddSearchCustomer(val ? 'search' : false);
                            }}
                          />
                        </>
                      ) : (
                        ''
                      )}
                    </>
                  ) : null}
                </div>
                <div className='NavbarRight'>
                  <div
                    className='navbarButtons'
                  >
                    {isAllowedQC && quichcheckoutPermission && (
                      <Link
                        className={clsx(
                          classes.quick__checkout__btn,
                          'qc__resp',
                        )}
                        to='/quickcheckout'
                      >
                        Quick Checkout
                      </Link>
                    )}
                  </div>
                  <div className='notification'>
                    {/* <div id='outerContainer'>
                      <a
                        href='https://help.torque360.co/hc/en-us'
                        id='container'
                        target='_blank'
                        rel='noreferrer'
                      >
                        <div className='item'>
                          <Icon>
                            <HelpOutlineRoundedIcon />
                          </Icon>
                        </div>

                        <div
                          className='circle'
                          style={{ animationDelay: '-2s' }}
                        />
                        <div
                          className='circle'
                          style={{ animationDelay: '-1s' }}
                        />
                        <div
                          className='circle'
                          style={{ animationDelay: '0s' }}
                        />
                      </a>
                    </div> */}
                    <Notification />{' '}
                  </div>
                  {/* {roleId !== 3 && ( */}
                  <>
                    <div className='OwnerInfo'>
                      {imgData.length ? (
                        <CardMedia
                          className={classes.mechanic__photo}
                          image={imgData}
                        />
                      ) : (
                        <Avatar />
                      )}

                      <div className='ownerName'>
                        <h5>{username ? username : ''}</h5>
                        {/* <p>Admin</p> */}
                      </div>
                    </div>
                    <UserDropdown classes={classes} tokenData={tokenData} />
                  </>
                  {/* )} */}
                  {/* {roleId === 3 && (
                    <Button
                      startIcon={<SignOutIcon className='sign__out__icon' />}
                      className='logout__btn_mech'
                      onClick={handleLogout}
                    >
                      Sign Out
                    </Button>
                  )} */}
                </div>
              </div>
            </Hidden>
            <div
              className={
                (!noPadding || isJobboard) && 'main__content__jobboard'
              }
            >
              {children}
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default memo(Layout);
